// src/plugins/vuetify.js
// Import styles
import 'vuetify/styles'

import { createVuetify } from 'vuetify'
import { md3 } from 'vuetify/blueprints'
import { ClickOutside } from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { de } from 'vuetify/locale'

import { appBranding } from '@/lib/features'

// Define CSS custom properties for gradients
const cssVariables = {
  '--markero-blue-gradient': 'linear-gradient(to right, #37C6F6, #377DF6)',
}

// Function to inject CSS variables
const injectCssVariables = () => {
  Object.entries(cssVariables).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value)
  })
}

// Call this when your app starts
injectCssVariables()

// Create custom theme
const light = {
  dark: false,
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    primary: (appBranding.isActive && appBranding.config.primary) || '#1668F5',
    secondary: (appBranding.isActive && appBranding.config.secondary) || '#424242',
    success: (appBranding.isActive && appBranding.config.success) || '#4CAF50',
    red: '#FF004A',
    orange: '#FE9930',
    error: '#FF004A',
    info: '#4895EF',
    warning: '#FE9930',
    leadActivity: '#07BEB8',
    systemActivity: '#4895EF',
    userActivity: '#C77DFF',
    skyLight: '#A2D2FF',
    dogerBlue: '#4895EF',

    // Alert colors
    'alert-success': '#5EB035',
    'alert-error': '#FF004A',
    'alert-warning': '#EAC109',
    'alert-info': '#377DF6',

    // Markero colors
    'markero-black': '#000000',
    'markero-light-yellow': '#ffd518',
    'markero-mid-yellow': '#f9b004',
    'markero-orange': '#f18815',
    'markero-light-orange': '#FF8A00',
    'markero-blue': '#377df6',
    'markero-dark-blue': '#1668F5',
    'markero-light-blue': '#37C6F6',
    'markero-dark-grey': '#414142',

    ...(appBranding.config.platform === 'bottimmo' && {
      grey: '#595959',
      'grey-lighten-4': '#EEF4F4',
      'on-surface': '#102A21',
      'rain-forest': '#175e51',
      'ganz-hell-turkis': '#add3d2',
    }),
  },
}

export default createVuetify({
  blueprint: md3,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  directives: {
    ClickOutside,
  },
  locale: {
    locale: 'de',
    fallback: 'de',
    messages: { de },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light,
    },
    variations: {
      colors: ['primary', 'secondary'],
      lighten: 1,
      darken: 2,
    },
  },
  defaults: {
    VBtn: {
      variant: 'flat',
      height: 40,
    },
    VCard: {
      elevation: 1,
      rounded: 'md',
    },
    VTab: {
      baseColor: 'grey-darken-1',
      rounded: 0,
    },
    VStepper: {
      mobileBreakpoint: 'md',
    },
  },
})
